import { render, staticRenderFns } from "./purchaseLeader.vue?vue&type=template&id=c7d859d8&scoped=true"
import script from "./purchaseLeader.vue?vue&type=script&lang=js"
export * from "./purchaseLeader.vue?vue&type=script&lang=js"
import style0 from "./purchaseLeader.vue?vue&type=style&index=0&id=c7d859d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d859d8",
  null
  
)

export default component.exports